import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'
import { ChatLauncher } from '@/components/generals/chat-assistant'

export const Layout: FC<LayoutProps> = ({ children, launcher = false }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col bg-white text-ink'>
            <a
                href='#main-content'
                className='sr-only z-[100] rounded-full bg-ink px-4 py-2 text-sm font-medium text-white focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to content
            </a>

            <Header />

            <main id='main-content' className='flex-1'>
                {children}
            </main>

            <Footer />

            {launcher && <ChatLauncher />}
        </div>
    )
}
